module.exports = __webpack_public_path__ + "images/category_lp/pc/down_arrow_b74b6adb0d39719fdae8549b1f222f49.jpg";